module.exports = __webpack_public_path__ + "img/scene24.d4da4060.gif";